// @ts-nocheck
import { createContext, useContext } from "react";

export const WithdrawPageContext = createContext(null);

export function useWithdrawPage() {
  const v = useContext(WithdrawPageContext);
  if (!v) throw new Error("useWithdrawPage must be used within WithdrawPage");
  return v;
}
